import { configureStore } from "@reduxjs/toolkit";
import TeamManagementSlice from "./slices/TeamManagementSlice";
import GoalsSlice from "./slices/GoalsSlice";
import FacilitiesSlice from "./slices/FacilitiesSlice";
import ReportsSlice from "./slices/ReportsSlice";

const store = configureStore({
    reducer: {
        teammanagement: TeamManagementSlice,
        goals: GoalsSlice,
        facilities: FacilitiesSlice,
        reports: ReportsSlice
    }
})

export default store;